import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import ColorAndHover from './ColorAndHover';
import General from './General';
import CarouselPreview from './Preview';
import { checkPermissionForLevel, checkPermissions } from '../../../../../lib/utils';
import { ACCESS_POINTS_GROUP, ACCESS_POINT_LEVEL } from '../../../../constants/AccessPoints';

class ThemeGallery extends Component {
    render() {
        return (
            <div className="ThemeGallery Theme-Content">
                <h1>Gallery</h1>
                <div className="subpages-main-content">
                    <div className="col-xs-12">
                        <div className="spark-panel spark-mar-t-1 spark-panel-buttons row">
                            <div className="spark-panel__content col-xs-12">
                                <CarouselPreview carouselPreview={this.props} gallery={this.props.gallery} />
                            </div>
                            <div className="spark-panel__content col-xs-12 col-sm-3">
                                <ColorAndHover
                                    id=""
                                    tagNameName="Font Styles"
                                    isDisabled={!this.props.hasAccessThemesEdit}
                                    tagName="closeIcon"
                                    fontData={this.props.closeIcon}
                                    colorLabel="Color"
                                    hoverLabel="Background"
                                    text={this.props.gallery.text}
                                />
                            </div>
                            <div className="spark-panel__content col-xs-12 col-sm-3">
                                <General
                                    id=""
                                    tagNameName="Overlay"
                                    tagName="general"
                                    isDisabled={!this.props.hasAccessThemesEdit}
                                    fontData={this.props.general}
                                    background={this.props.gallery.overlay.background}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ThemeGallery.propTypes = {
    children: PropTypes.element
};

ThemeGallery.contextTypes = {
    store: PropTypes.object
};

const mapStateToProps = state => {
    return {
        ...state.app.data.theme.carousel,
        ...state.theme.carousel,
        gallery: state.app.data.theme.carousel.gallery,
        hasAccessThemesEdit: checkPermissionForLevel(
            state.oauth.accessLevel,
            ACCESS_POINTS_GROUP.THEMES,
            ACCESS_POINT_LEVEL.EDIT,
            state.oauth.userPermissionLevels,
            state.app.selected.level
        )
    };
};

export default connect(mapStateToProps)(ThemeGallery);



// WEBPACK FOOTER //
// ./src/components/pages/theme/carousel/index.js